import "core-js/modules/es.array.sort.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "small"
    }
  }, [_c("el-form-item", [_c("div", {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600",
      "line-height": "26px"
    }
  }, [_vm._v(" 常见问题分类 ")])])], 1), _c("el-form", {
    attrs: {
      size: "small"
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.showModal();
      }
    }
  }, [_vm._v("新增 ")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "categoryZh",
      label: "中文名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "categoryEn",
      label: "英文名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "categoryTw",
      label: "繁体名称"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "排序",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          attrs: {
            placeholder: "序号",
            type: "number"
          },
          model: {
            value: scope.row.sort,
            callback: function callback($$v) {
              _vm.$set(scope.row, "sort", $$v);
            },
            expression: "scope.row.sort"
          }
        }, [_c("el-button", {
          attrs: {
            slot: "append"
          },
          on: {
            click: function click($event) {
              return _vm.update(scope.row);
            }
          },
          slot: "append"
        }, [_vm._v("保存 ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "address",
      label: "操作",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.toSubPage(row);
            }
          }
        }, [_vm._v("问题列表 ")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.showModal(row);
            }
          }
        }, [_vm._v("编辑 ")]), _c("el-popconfirm", {
          attrs: {
            title: "要删除这条分类吗？"
          },
          on: {
            confirm: function confirm($event) {
              return _vm.delData(row);
            }
          }
        }, [_c("span", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("el-button", {
          staticStyle: {
            color: "#f92e2e",
            "font-size": "12px",
            "margin-left": "10px"
          },
          attrs: {
            type: "text"
          }
        }, [_vm._v("删除")])], 1)])];
      }
    }])
  })], 1), _c("Modal", {
    ref: "modal",
    on: {
      save: _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };